import {
	CheckCircle,
	Copy,
	Lock,
	QrCode,
	Settings,
	Trash2,
	Unlock,
	User,
	Users,
} from "lucide-react";
import React, { useState } from "react";
import StatusBadge from "../_shared/StatusBadge"; // Importiere StatusBadge

interface RaumStatusLeisteProps {
	raumId: string;
	passwort?: string; // Passwort ist optional
	nurBesitzerEdit: boolean;
	istBesitzer: boolean;
	onEinstellungenClick: () => void;
	onLinkKopieren: () => void;
	onQrAnzeigen: () => void; // Hinzugefügt für QR-Code
	onNurBesitzerEditClick?: () => void;
	onDeleteClick?: () => void;
}

export function RaumStatusLeiste({
	raumId,
	passwort,
	nurBesitzerEdit,
	istBesitzer,
	onEinstellungenClick,
	onLinkKopieren,
	onQrAnzeigen, // Hinzugefügt
	onNurBesitzerEditClick,
	onDeleteClick,
}: RaumStatusLeisteProps) {
	const [kopiert, setKopiert] = useState(false);

	const handleLinkKopieren = () => {
		setKopiert(true);
		onLinkKopieren();
		setTimeout(() => setKopiert(false), 2000);
	};

	const editRightsTooltip = istBesitzer
		? "Klicken zum Ändern der Bearbeitungsrechte"
		: undefined;

	return (
		<div className="flex flex-col flex-wrap items-center justify-between gap-3 rounded-xl border border-gray-100 bg-white p-3 shadow-sm sm:flex-row dark:border-gray-700 dark:bg-gray-800/70">
			{/* Linker Bereich: Raum-ID & Link-Kopieren */}
			<div className="flex flex-wrap items-center gap-2">
				<StatusBadge
					className="px-3 py-1"
					color="gray"
					text={
						<>
							<span className="mr-1 font-medium text-gray-500 dark:text-gray-400">
								Raum:
							</span>
							<span className="font-mono text-blue-600 dark:text-blue-400">
								{raumId}
							</span>
						</>
					}
				/>
				<StatusBadge
					className="px-3 py-1"
					color="gray"
					icon={kopiert ? CheckCircle : Copy}
					iconClassName={kopiert ? "text-green-500" : ""}
					onClick={handleLinkKopieren}
					text="Link kopieren"
				/>
				<StatusBadge
					className="px-3 py-1"
					color="gray"
					icon={QrCode}
					onClick={onQrAnzeigen}
					text="QR-Code"
					tooltip="QR-Code für diesen Raum anzeigen"
				/>
			</div>

			{/* Rechter Bereich: Status-Badges & Einstellungen */}
			<div className="flex flex-wrap items-center gap-2">
				{/* Passwort Status */}
				<StatusBadge
					color={passwort ? "amber" : "gray"}
					icon={passwort ? Lock : Unlock}
					text={passwort ? "Geschützt" : "Offen"}
					tooltip={
						passwort ? "Raum ist passwortgeschützt" : "Kein Passwort gesetzt"
					}
				/>

				{/* Bearbeitungsrechte */}
				<StatusBadge
					color={nurBesitzerEdit ? "blue" : "green"}
					icon={nurBesitzerEdit ? User : Users}
					iconClassName={
						istBesitzer && onNurBesitzerEditClick
							? "group-hover:text-blue-500 dark:group-hover:text-blue-300"
							: ""
					}
					onClick={istBesitzer ? onNurBesitzerEditClick : undefined}
					text={nurBesitzerEdit ? "Nur Besitzer" : "Für alle"}
					tooltip={editRightsTooltip}
				/>

				{/* Aktionen rechts: Einstellungen, Löschen (ganz rechts) */}
				{istBesitzer && (
					<StatusBadge
						color="gray"
						icon={Settings}
						onClick={onEinstellungenClick}
						text="Einstellungen"
						tooltip="Raumeinstellungen"
					/>
				)}
				{istBesitzer && onDeleteClick && (
					<StatusBadge
						color="rose"
						icon={Trash2}
						onClick={onDeleteClick}
						text="Löschen"
						tooltip="Diesen Raum löschen"
					/>
				)}

				{/* Ablaufdatum und Verlängerung entfernt */}
			</div>
		</div>
	);
}
